export default __webpack_public_path__ + "static/media/48.08908529.png";